import axios from '../api/axios';

export async function getVehicles(pagination, options) {

  const headers = {
    'page': pagination.page,
    'limit': pagination.total,
  };

  options['headers'] = headers;


  const res = await axios.get(`/vehicles`, options);
  const data = {
    vehicles: res.data.results,
    count: res.data.count,
  };
  return data;
}

export async function getVehicle(vehicleId, options) {
  const res = await axios.get(`/vehicles/${vehicleId}`, options);
  return res.data;
}

export async function createVehicle(body) {
  const res = await axios.post(`/vehicles`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
}

export async function updateVehicle(vehicleId, body) {
  const res = await axios.patch(
    `/vehicles/${vehicleId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return res.data;
}

export async function deleteVehicle(vehicleId) {
  const res = await axios.delete(`/vehicles/${vehicleId}`);

  return res.data;
}
